import React from 'react';
import ContentContainer from '../ContentContainer/ContentContainer';
import PFSContactCta from '../PFSContactCta/PFSContactCta';
import PFSServiceHeader from '../PFSServiceHeader/PFSServiceHeader';
import PFSServicePoints from '../PFSServicePoints/PFSServicePoints';
import PFSWhyChoosePFS from '../PFSWhyChoosePFS/PFSWhyChoosePFS';
import globalStyles from '../../styles/global.module.css';

import PFSMeetTheTeam from '../PFSMeetTheTeam/PFSMeetTheTeam';
import peopleOpsImage from './peopleOps.jpg'
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { WhatWeDoBreadcrumb } from '../PFSWhatWeDoIndex/PFSWhatWeDoIndex';
import { useLocation } from 'react-router-dom';

const PFSWhatWeDoPeopleOps = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    WhatWeDoBreadcrumb,
    {
      label: 'People Operations',
      url: pathname,
    },
  ]);
  return(
  <div data-testid='PFSWhatWeDoPeopleOps'>
    <ContentContainer>
      <PFSServiceHeader title='Solving for the Modern Nonprofit.' subtitle='People Operations' />
      <div className={globalStyles.IntroContainer}>
        <img alt='A calculator' src={peopleOpsImage} className={globalStyles.IntroImage} />
        <div className={globalStyles.IntroText}>
          <p>At PFS Global, our PeopleOps team provides comprehensive payroll and HR solutions tailored to the unique needs of non-profit organizations. From accurate payroll processing, including grant and fund allocation tracking, to HR compliance support, we simplify and streamline the management of your organization's team operations.</p>
          <p>By entrusting us with your PeopleOps needs, you can ensure that your employees and staff are paid accurately, on time, and with the confidence that your organization's complex HR compliance is expertly managed. Contact us today to learn how we can help you support your team and optimize your operations so you can keep your focus on your mission.</p>
        </div>
      </div>
      <PFSServicePoints
        title='Payroll Processing'
        points={[
          'Payroll Processing',
          'Time and Attendance Management',
          'Retirement Deductions and Reporting',
          'Health Insurance Deductions',
          'Dental and Vision Insurance Deductions',
          'Supplemental Insurance Deductions',
          'Pay-as-You-Go Workers’ Compensation Reporting',
          'W2/W3 Processing',
        ]}
      />
      <PFSServicePoints
        title='Recruiting'
        points={[
          'Draft job descriptions',
          'Compensation and Job Market analysis',
          'Review of exempt vs. non-exempt classifications',
          'Review of non-discretionary bonuses credited towards overtime',
          'Review employee versus contractor classifications',
          'Review qualification for statutory employee classifications',
          'Post job ads (client paid)',
          'Review and send top resumes to leaders or managers',
          'Schedule interviews',
          'Collect Application for Employment and Background Check Authorization and Notice to Applicant',
          'Schedule Try Out Times (optional)',
          'Reference checks',
          'Schedule a second interview or try out time',
          'Draft and send an offer letter and instructions for the first day',
          'Background checks (client paid)',
          'Schedule first date of employment and onboarding timeline',
        ]}
      />
      <PFSServicePoints
        title='Onboarding'
        points={[
          {
            label: 'Employee Onboarding',
            subpoints: [
              'Coordinate with IT',
              'Coordinate with Direct Report',
              'Guide Orientation',
            ],
          },
          {
            label: 'Employee Document Collection',
            subpoints: [
              'Application for Employment',
              'Offer Letter (Exempt or Non-Exempt)',
              'Background Check Authorization and Notice to Applicant',
              'Employee Handbook',
              'Handbook Receipt and Employee Acknowledgement',
              'Non-Disclosure Agreement',
              'W4 (and state equivalent)',
              'I-9',
              'Employee Direct Deposit Authorization',
              'Arbitration Agreement (if applicable)',
              'Work From Home Policy (if applicable)',
            ],
          },
        ]}
      />
      <PFSServicePoints
        title='Maintenance'
        points={[
          'Management of Human Resources Information System (HRIS)',
          'Reporting of key HR Metrics',
          'Dispute Resolution and/or Investigation',
          'Complaint or Concern Intake, Checklist, and Conclusion Form',
          'Timesheet Certifications',
          'Consensual Relationship Agreements',
          'Disciplinary Action Notice',
          'Performance Improvement Plans (PIP)',
          'Employee Status Change Form',
          'Manage the workflow of probation period and annual performance reviews',
          {
            label: 'Benefits management (enrollment, updates, and renewals):',
            subpoints: [
              {
                label: 'Retirement plan',
                subpoints: [
                  'Third-party administrator',
                ],
              },
              {
                label: 'Health insurance',
                subpoints: [
                  'Section 125 Premium Only Plan (POP)',
                  'COBRA',
                ],
              },
              'Dental and vision insurance',
              'Supplementing insurance',
            ],
          },
          'Workers’ Compensation administration',
          {
            label: 'Management of employment law firm engagement',
            subpoints: [
              'Annual compliance reviews of employee documents',
              'Annual compliance review of company policies',
            ],
          },
          'Management of virtual Sexual Harassment Prevention Training',
          'Management of Workplace Violence Prevention Plan (WVPP) and Injury and Illness Prevention Plan (IIPP) policies and training',
          'Employment posters and notices',
          {
            label: 'Employee file management',
            subpoints: [
              'Personnel files',
              'Confidential file (including medical)',
              'Payroll file',
              'I-9 file',
            ],
          },
          {
            label: 'Strategic Planning Around:',
            subpoints: [
              'Talent Growth and Succession Planning',
              'Career Path Development',
              'Culture',
              'Retention',
              'Appreciation Team Building',
              'Continuing Education',
              'Leadership Development',
            ],
          },
        ]}
      />
      <PFSServicePoints
        title='Offboarding'
        points={[
          'Exit interviews',
          'Termination packages',
          'Separation Information and Final Paycheck Acknowledgement',
          'Separation and Release Agreement',
          'Exit Interview Questionnaire (Non-Termination)',
          'Management of unemployment claims: responses, disputes, and appeals',
          'Employment legal claims coordination with employment law firm',
        ]}
      />
    </ContentContainer>
    <PFSWhyChoosePFS />
    <PFSMeetTheTeam department='PeopleOps' />
    <br />
    <br />
    <br />
    <br />
    <br />
    <PFSContactCta ctaText='Call us today!' />
  </div>
)};

PFSWhatWeDoPeopleOps.propTypes = {};

export default PFSWhatWeDoPeopleOps;
